export default {
    serverURL:   'https://comaygao.com',
    api:         'https://comaygao.com/graphql',
    // serverURL:   'http://localhost:8080',
    // api:         'http://localhost:8080/graphql',
    defaultLang: 'vn',
}
